import React from 'react'
import { Link } from 'react-router-dom'

export const ROUTE_OPEN = true

const NotFound = () => {
  return (
    <div className="page-wrap d-flex flex-row align-items-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 text-center">
            <span className="display-1 d-block">404</span>
            <div className="mb-4 lead">Oops! We can't seem to find the page you are looking for.</div>
            <Link to='/'>Back to Home page</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound;
